import { render, staticRenderFns } from "./loyalty-input.vue?vue&type=template&id=fc84f3dc&scoped=true"
import script from "./loyalty-input.ts?vue&type=script&lang=ts&external"
export * from "./loyalty-input.ts?vue&type=script&lang=ts&external"
import style0 from "./loyalty-input.scss?vue&type=style&index=0&id=fc84f3dc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc84f3dc",
  null
  
)

export default component.exports